<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    :title="title"
    @close="close"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="type" prop="type">
        <el-input v-model="form.type"></el-input>
      </el-form-item>

      <el-form-item label="fileKey" prop="fileKey">
        <el-input v-model="form.fileKey"></el-input>
      </el-form-item>

      <el-form-item label="status" prop="status">
        <el-input v-model="form.status"></el-input>
      </el-form-item>

      <el-form-item label="totalCount" prop="totalCount">
        <el-input v-model="form.totalCount"></el-input>
      </el-form-item>

      <el-form-item label="successCount" prop="successCount">
        <el-input v-model="form.successCount"></el-input>
      </el-form-item>

      <el-form-item label="processedCount" prop="processedCount">
        <el-input v-model="form.processedCount"></el-input>
      </el-form-item>

      <el-form-item label="elapsed" prop="elapsed">
        <el-input v-model="form.elapsed"></el-input>
      </el-form-item>

      <el-form-item label="createUserId" prop="createUserId">
        <el-input v-model="form.createUserId"></el-input>
      </el-form-item>

      <el-form-item label="createUserName" prop="createUserName">
        <el-input v-model="form.createUserName"></el-input>
      </el-form-item>

      <el-form-item label="createTime" prop="createTime">
        <el-input v-model="form.createTime"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      form: {},
      rules: {},
      dialogFormVisible: false,
      loading: false,
    };
  },
  methods: {
    async showEdit(row) {
      if (!row) {
        this.title = "添加";
      } else {
        this.title = "编辑";
        this.form = await this.axios.get("mall:/api/admin/import-task/" + row.id);
      }
      this.dialogFormVisible = true;
    },
    close() {
      this.$refs.formRef.resetFields();
      this.form = {};
      this.dialogFormVisible = false;
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          let url;
          if (this.title === "添加") {
            url = "mall:/api/admin/import-task/create";
          } else if (this.title === "编辑") {
            url = "mall:/api/admin/import-task/update";
          }

          const params = {
            ...this.form,
          };
          try {
            await this.axios.form(url, params);
            this.$message.success("保存成功");
            this.$emit("success");
            this.close();
          } catch (e) {
            this.$notify.error({ title: "错误", message: e.message || e });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
